import React, { Component, Fragment } from "react"
import { Formik, Form, Field } from "formik"
import { withRouter } from "../../helpers/withRouter"
import {
  Row,
  ButtonGroup,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Card,
  CardBody,
  Col,
  Input,
} from "reactstrap"
import ListPageHeader from "../../components/custom/ListPageHeader"
import ListPage from "../../components/custom/ListPage"
import { taskMasterValidation } from "../../helpers/validations"
import { Message } from "../../helpers/language_helper"
import { SuccessMessage, ErrorMessage } from "../../helpers/notifications"
import { QueryRequest, MutateRequest } from "../../helpers/service_helper"
import {
  createTaskMasterMutation,
  updateTaskMasterMutation,
  deleteTaskMasterMutation,
  getAllTaskMasterQuery,
  getOneTaskMasterQuery,
  getAllAgeGroup,
  fileUploadQuery,
} from "./Queries"
import axios from "axios"
import { Helmet } from "react-helmet-async"
import FileDisplay from "components/custom/FileDisplay"
import { StatusCodes } from "../../constants/defaultValues"

class TaskMaster extends Component {
  constructor(props) {
    super(props)
    this.state = {
      manageModal: false,
      Label: "",
      currentpage: 1,
      buttonAction: false,
      isLoading: true,
      pageSizeOptions: [25, 50, 100, 500],
      pageLimit: 25,
      totalCount: 0,
      keyField: "id",
      viewModal: false,
      taskMasterList: [],

      listRequestModel: {
        searchString: "",
        pageNumber: 1,
        pageLimit: 25,
      },
      taskMaster: {
        taskName: "",
        ageGroupId: "",
        icon: "",
      },
      columns: [
        {
          name: "Icon",
          selector: row => row.iconURL,
          sortable: true,
          width: "10%",
          cell: row => (
            <span style={{ padding: "10px" }}>
              <img
                style={{ width: "50px", height: "50px" }}
                src={row.iconURL}
                alt={row.iconURL}
              />
              {/* {row.iconURL ? <FileDisplay Value={row.iconURL} /> : ""} */}
            </span>
          ),

          // <a href={row.iconURL}>{row.iconURL ? row.iconURL : ""}</a>
        },
        {
          name: "Name",
          selector: row => row.taskName,
          sortable: true,
          cell: row => <span>{row.taskName ? row.taskName : ""}</span>,
        },
        // {
        //   name: "Age Group",
        //   selector: "ageGroupId",
        //   sortable: true,
        //   cell: row => <span>{row.ageGroupId ? row.ageGroupId : ""}</span>,
        // },

        {
          name: "Action",
          selector: row => row.action,
          sortable: false,
          cell: row => (
            <Row>
              <ButtonGroup className="mb-2" style={{ top: "4px" }}>
                <Button
                  outline
                  color="primary"
                  className="mobileViewFont ms-2"
                  onClick={() => this.handleEdit(row)}
                >
                  {Message("edit")}
                </Button>

                <Button
                  outline
                  color="danger"
                  className="mobileViewFonts ps-1 pe-1 ms-2"
                  onClick={() => this.toggleDeleteModal(row)}
                >
                  {Message("delete")}
                </Button>
              </ButtonGroup>
            </Row>
          ),
        },
      ],
    }
  }

  componentDidMount() {
    this.getAllTaskMaster()
    //  this.getAllAgeGroup()
  }
  // getAllAgeGroup = async () => {
  //   await QueryRequest(getAllAgeGroup).then(res => {
  //     this.setState({
  //       ageGroupList: res.data?.getAllAgeGroupMasters?.items.map(function (a) {
  //         return { value: a.id, label: a.ageGroupTitle }
  //       }),
  //     })
  //   })
  //console.log(this.state.ageGroupList)
  //}

  getAllTaskMaster = async value => {
    this.setState({
      isLoading: true,
    })
    const { listRequestModel } = this.state
    var values = listRequestModel
    const response = await QueryRequest(getAllTaskMasterQuery, values)
    var taskMastersValue = response?.data?.getAllTaskMasters?.items
    //console.log(taskMastersValue)
    if (taskMastersValue) {
      this.setState({
        isLoading: false,
        taskMasterList: taskMastersValue,
        totalPage:
          response?.data?.getAllTaskMasters?.pagination?.totalCount /
          response?.data?.getAllTaskMasters?.pagination?.pageLimit,
        totalCount: response?.data?.getAllTaskMasters?.pagination?.totalCount,
      })
    } else
      this.setState({
        isLoading: false,
      })
  }

  /** handle list page  start  */
  handleSort = (column, sortDirection) => {
    var sortObj = {}
    sortObj[column.selector] = sortDirection === "asc" ? "asc" : "desc"
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          sortCondition: sortObj,
        },
      },
      function () {
        this.getAllTaskMaster()
      }
    )
  }

  handlePerRowsChange = async perPage => {
    this.setState(
      {
        pageLimit: perPage,
        pageNumber: 1,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageLimit: perPage,
          pageNumber: 1,
        },
      },
      async function () {
        this.getAllTaskMaster()
      }
    )
  }

  handlePageChange = async page => {
    this.setState(
      {
        pageNumber: page,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageNumber: page,
        },
      },
      function () {
        this.getAllTaskMaster()
      }
    )
  }

  searchQueryChanged = search => {
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          searchString: search.target.value,
        },
      },
      function () {
        if (
          this.state.listRequestModel.searchString === "" ||
          this.state.listRequestModel.searchString.length > 2
        ) {
          this.getAllTaskMaster()
        }
      }
    )
  }

  handleEdit = row => {
    console.log(row)
    if (row) {
      this.setState({
        taskMaster: row,
        iconURL: row.iconURL,
        manageModal: !this.state.manageModal,
        IsEdited: true,
        Label: "Edit",
      })
    }
  }

  /** Submit Function Start */
  handleSubmit = async values => {
    this.state.Label == "Add"
      ? this.addTaskMaster(values)
      : this.editTaskMaster(values)
    // const response = values.id
    //   ? await MutateRequest(updateTaskMasterMutation, values)
    //   : await MutateRequest(createTaskMasterMutation, values)
    // var taskMasterValue = response?.data
    // if (taskMasterValue && values.id) {
    //   SuccessMessage(Message("taskMaster.update")),
    //     this.setState({
    //       manageEditModal: !this.state.manageEditModal,
    //     })
    //   this.getAllTaskMaster()
    // } else {
    //   SuccessMessage(Message("taskMaster.add")),
    //     this.setState({
    //       manageModal: !this.state.manageModal,
    //     })
    //   this.getAllTaskMaster()
    // }
  }

  addTaskMaster = async values => {
    let data = {
      taskName: values.taskName,
      iconURL: values.iconURL,
    }
    //if (values.ageGroupId) data.ageGroupId = values.ageGroupId
    if (values.iconURL) data.iconURL = values.iconURL

    await MutateRequest(createTaskMasterMutation, { data: data })
      .then(res => SuccessMessage(Message("taskMaster.add")))
      .catch(e => ErrorMessage(e))
    this.setState({
      manageModal: !this.state.manageModal,
    })
    this.getAllTaskMaster()
    // if (values.iconURL) {
    //   let fileupload = {
    //     type: "photo",
    //     fileName: values.iconURL?.name,
    //   }

    //   const fileUploadresponse = await QueryRequest(fileUploadQuery, fileupload)

    //   let data = fileUploadresponse?.data?.getUploadUrl
    //   //console.log(data)
    //   //console.log(values.iconURL)
    //   if (data.status === "Success") {
    //     axios
    //       .post(data.url, values.iconURL, {
    //         headers: { "Content-Type": values.iconURL?.type },
    //       })
    //       .then(res => {
    //         if (res.status.toString() === StatusCodes.Success) {
    //           let data = {
    //             taskName: values.taskName,
    //             ageGroupId: values.ageGroupId,
    //             iconURL: data.url.split("?")[0],
    //           }
    //           //console.log(data)
    //           //  MutateRequest(createTaskMasterMutation, { data: data })
    //           //   .then(res => SuccessMessage(Message("task.add")))
    //           //   .catch(e => ErrorMessage(e))
    //           this.setState({
    //             manageModal: !this.state.manageModal,
    //           })
    //           this.getAllTaskMaster()
    //         } else {
    //           ErrorMessage(Message("fieldUpload.error"))
    //         }
    //       })
    //       .catch(err => ErrorMessage(Message(err)))
    //   } else {
    //     ErrorMessage(Message("fieldUpload.error"))
    //   }
    // } else {
    //   alert("error")
    // }

    // this.setState({
    //   manageModal: !this.state.manageModal,
    // })
    // this.getAllTaskMaster()
  }

  editTaskMaster = async values => {
    let Data = {
      id: this.state.taskMaster.id,
      data: {
        taskName: values.taskName,
      },
    }

    if (values.ageGroupId) Data.data.ageGroupId = values.ageGroupId
    if (values.iconURL) Data.data.iconURL = values.iconURL
    await MutateRequest(updateTaskMasterMutation, Data)
      .then(res => SuccessMessage(Message("taskMaster.update")))
      .catch(e => ErrorMessage(e))
    this.setState({
      manageModal: !this.state.manageModal,
    })
    this.getAllTaskMaster()
  }

  addBtnClick = () => {
    this.setState({
      taskMaster: {},
      manageModal: !this.state.manageModal,
      Label: "Add",
    })
  }

  toggleDeleteModal = row => {
    this.setState({
      deleteModal: !this.state.deleteModal,
      taskMaster: row,
    })
  }

  toggleManageModal = () => {
    this.setState({
      taskMaster: {},
      manageModal: !this.state.manageModal,
    })
  }

  deleteTaskMaster = async id => {
    var values = {
      id: id,
    }
    const response = await MutateRequest(deleteTaskMasterMutation, values)
    var taskMasterdeleteValue = response?.data
    if (taskMasterdeleteValue.deleteTaskMaster.status === "Success") {
      SuccessMessage(Message("taskMaster.delete"))
      this.getAllTaskMaster()
      this.setState({
        buttonAction: false,
        deleteModal: !this.state.deleteModal,
      })
    } else {
      ErrorMessage(Message("api.error"))
      this.setState({
        buttonAction: false,
      })
    }
  }

  toggleViewModal = url => {
    this.setState({
      viewModal: !this.state.viewModal,
      documentView: url,
      taskMasterDetail: url ? url : "",
    })
  }

  render() {
    const initialValues = this.state.taskMaster
    const conditionalRowStyles = [
      {
        when: row => row,
        style: {
          "&:hover": {
            cursor: "pointer",
          },
        },
      },
    ]
    return (
      <Fragment>
        <Helmet>
          <title>{Message("title.taskMaster")}</title>
        </Helmet>
        <div className="page-content">
          <div className="container-fluid">
            <Card>
              <CardBody>
                <ListPageHeader
                  heading={`${"Home"}.${"Tasks"}`}
                  buttonText={Message("add.taskMaster")}
                  onTextChange={this.searchQueryChanged}
                  buttonClick={this.addBtnClick}
                  searchValue={this.state.listRequestModel.searchString}
                />

                <ListPage
                  conditionalRowStyles={conditionalRowStyles}
                  columns={this.state.columns}
                  data={this.state.taskMasterList}
                  keyField={this.state.keyField}
                  totalCount={this.state.totalCount}
                  rowClicked={this.HandleRowClicked}
                  onSort={this.handleSort}
                  pageLimit={this.state.pageLimit}
                  pageSizeOptions={this.state.pageSizeOptions}
                  rowsPerPageOnChange={this.handlePerRowsChange}
                  pageChange={this.handlePageChange}
                  isDataLoading={this.state.isLoading}
                  overFlowXRemoval={true}
                />
              </CardBody>
            </Card>
            <Modal
              isOpen={this.state.deleteModal}
              toggle={this.toggleDeleteModal}
            >
              <ModalHeader toggle={this.toggleDeleteModal}>
                {Message("delete.taskMaster")}
              </ModalHeader>

              <ModalBody>
                <Fragment>
                  <Row className="mb-1 mt-2">
                    <p className="ms-3 me-3 font-size-15">
                      {Message("delete.confirmation")}{" "}
                      <span>
                        {" "}
                        <strong> {this.state.taskMaster?.taskName}</strong>{" "}
                        {Message("task")}{" "}
                      </span>
                      {"?"}
                    </p>
                  </Row>
                </Fragment>
              </ModalBody>

              <ModalFooter>
                <FormGroup className="float-sm-right ">
                  <Button
                    type="submit"
                    color="primary"
                    onClick={() =>
                      this.deleteTaskMaster(this.state.taskMaster.id)
                    }
                  >
                    {Message("yes")}
                  </Button>
                  <Button
                    color="danger"
                    className="ms-2"
                    onClick={() => this.toggleDeleteModal()}
                  >
                    {Message("no")}
                  </Button>
                </FormGroup>
              </ModalFooter>
            </Modal>
            <Modal
              isOpen={this.state.manageModal}
              toggle={this.toggleManageModal}
              size="md"
            >
              <ModalHeader toggle={this.toggleManageModal}>
                {this.state.Label == "Add"
                  ? Message("add.taskMaster")
                  : Message("update.taskMaster")}
              </ModalHeader>
              <Formik
                initialValues={initialValues}
                validationSchema={taskMasterValidation}
                onSubmit={this.handleSubmit}
                validateOnBlur={false}
                validateOnChange={false}
              >
                {({ errors, values, setFieldValue }) => (
                  <Form className="av-tooltip tooltip-label-bottom">
                    <ModalBody>
                      <Fragment>
                        <Row>
                          <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {" "}
                                {Message("name")}
                              </Label>

                              <Field
                                autoComplete="off"
                                className="form-control"
                                name="taskName"
                                type="text"
                              />
                              {errors.taskName && (
                                <div className="invalid-feedback d-block">
                                  {errors.taskName}
                                </div>
                              )}
                            </FormGroup>
                          </Col>
                          <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label className="requiredField">
                                {Message("Image")}
                              </Label>
                              <Input
                                type="file"
                                name="iconURL"
                                id="iconURL"
                                onChange={async e => {
                                  let file = e.target.files[0]
                                  let fileupload = {
                                    type: "photo",
                                    fileName: e.target.files?.[0]?.name.trim(),
                                  }
                                  console.log(e.target.files[0])
                                  const fileUploadresponse = await QueryRequest(
                                    fileUploadQuery,
                                    fileupload
                                  )
                                  let data =
                                    fileUploadresponse?.data?.getUploadUrl
                                  let url = data.url.split("?")[0]
                                  axios
                                    .put(data.url, file, {
                                      headers: {
                                        "Content-Type": file.type,
                                      },
                                    })
                                    .then(async res => {
                                      console.log(res)
                                      if (
                                        res.status.toString() ===
                                        StatusCodes.Success
                                      ) {
                                        console.log(res.config.url)
                                      } else {
                                        ErrorMessage(
                                          Message("fieldUpload.error")
                                        )
                                      }
                                    })
                                    .catch(err => alert("Image Uploaded"))
                                  setFieldValue("iconURL", url)
                                  // this.handleImageChange(e)
                                }}
                              />
                              {values.iconURL && (
                                <img
                                  src={values.iconURL}
                                  alt="preview"
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "200px",
                                  }}
                                />
                              )}
                            </FormGroup>
                            {errors.iconURL && (
                              <div className="invalid-feedback d-block">
                                {errors.iconURL}
                              </div>
                            )}
                          </Col>
                          {/* <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <DropDown
                                label="Age Group"
                                components={{
                                  Input: CustomSelectInput,
                                }}
                                className="react-select"
                                classNamePrefix="react-select"
                                isSearchable
                                isClearable={true}
                                value={
                                  values.ageGroupId &&
                                  (typeof values.ageGroupId === "string"
                                    ? this.state.ageGroupList.find(
                                        r => r.value === values.ageGroupId
                                      )
                                    : this.state.ageGroupList.find(
                                        r => r.value === values.ageGroupId
                                      ))
                                }
                                options={this.state.ageGroupList}
                                ClearAction={() => {
                                  setFieldValue(`ageGroupId`, "")
                                }}
                                Action={entity => {
                                  setFieldValue(
                                    `ageGroupId`,
                                    entity ? entity.value : ""
                                  )
                                }}
                                errors={errors?.ageGroupId}
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="12" xl="12" sm="12" md="12" xs="12">
                            <FormGroup className="mt-2 form-group has-float-label">
                              <Label>Icon</Label>
                              <br />
                              <Input
                                style={{ display: "none" }}
                                id="Image"
                                type="file"
                                onChange={e => {
                                  this.setState({
                                    photo: e.target.files[0],
                                  })
                                  setFieldValue("iconURL", e.target.files[0])
                                }}
                              />
                              <label for="Image" class="btn btn-secondary">
                                <i class="far fa-file"></i>
                              </label>
                              <br />
                              {values.iconURL ? (
                                <Label>{values.iconURL?.name}</Label>
                              ) : (
                                ""
                              )}
                              {this.state.Label == "Edit" && (
                                <FileDisplay value={values.iconURL} />
                              )}
                              {errors.iconURL && (
                                <div className="invalid-feedback d-block">
                                  {errors.iconURL}
                                </div>
                              )}
                            </FormGroup>
                          </Col> */}
                        </Row>
                      </Fragment>
                    </ModalBody>

                    <ModalFooter>
                      <div className="container-fluid">
                        <Row>
                          <Col sm={6} className="required">
                            &nbsp;{Message("mandatory.fields")}
                          </Col>
                          <Col sm={6}>
                            <div className="text-sm-right d-none d-sm-block">
                              <FormGroup className="float-sm-right ">
                                <Button type="submit" color="primary">
                                  {this.state.Label == "Edit"
                                    ? "Update"
                                    : "Add"}
                                </Button>

                                <Button
                                  color="danger"
                                  className="ms-2"
                                  onClick={() => this.toggleManageModal()}
                                >
                                  {Message("cancel")}
                                </Button>
                              </FormGroup>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </ModalFooter>
                  </Form>
                )}
              </Formik>
            </Modal>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withRouter(TaskMaster)
